module.exports = __webpack_public_path__ + "img/mantovani-front.f9a2719a.jpg";